import { render, staticRenderFns } from "./category-suggested-products-list.vue?vue&type=template&id=0d23c416&"
import script from "./category-suggested-products-list.vue?vue&type=script&lang=ts&"
export * from "./category-suggested-products-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports